import type { StateCreator } from "zustand";
import type { PhotographicEventPayloadType } from "@/repositories/photographic-records/types";

export interface PendingCameraEvent extends PhotographicEventPayloadType {
  timestamp: number;
  retryCount: number;
}

export interface PendingCameraEventsSliceState {
  pendingCameraEvents: PendingCameraEvent[];
  addPendingCameraEvent: (payload: PhotographicEventPayloadType) => void;
  removePendingCameraEvent: (timestamp: number) => void;
  updatePendingCameraEvent: (timestamp: number, updates: Partial<PendingCameraEvent>) => void;
  clearPendingCameraEvents: () => void;
}

export const createPendingCameraEventsSlice: StateCreator<
  PendingCameraEventsSliceState,
  [],
  [],
  PendingCameraEventsSliceState
> = (set, _get) => ({
  pendingCameraEvents: [],
  addPendingCameraEvent: (payload) => {
    const newPendingCameraEvent: PendingCameraEvent = {
      ...payload,
      timestamp: Date.now(),
      retryCount: 0,
    };
    set((state) => ({
      pendingCameraEvents: [...state.pendingCameraEvents, newPendingCameraEvent],
    }));
  },
  removePendingCameraEvent: (timestamp) =>
    set((state) => ({
      pendingCameraEvents: state.pendingCameraEvents.filter((event) => event.timestamp !== timestamp),
    })),
  updatePendingCameraEvent: (timestamp, updates) =>
    set((state) => ({
      pendingCameraEvents: state.pendingCameraEvents.map((event) => {
        if (event.timestamp === timestamp) {
          return { ...event, ...updates };
        }
        return event;
      }),
    })),
  clearPendingCameraEvents: () => set({ pendingCameraEvents: [] }),
});